import React, { useEffect, useRef } from 'react';
import './Devpage.css';
import { Devcard, Underline } from '../../widgets';
import { batch_2025, batch_2026, batch_2027, batch_2028, guide_team, staff_incharge } from '../../constants/devteam';

const Devpage = () => {
  useEffect(() => {
    document.title = 'ACCET-Web Development Team';
  }, []);

  return (
    <div className="webdevpage">
      <Underline heading="Development Team" />
      <Underline heading="2021-2025 Batch" />
      <div className="dev_profile_holder" >
        {batch_2025.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>

      <Underline heading="2022-2026 Batch" />
      <div className="dev_profile_holder" >
        {batch_2026.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>

      <Underline heading="2023-2027 Batch" />
      <div className="dev_profile_holder" >
        {batch_2027.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>
      <Underline heading="2024-2028 Batch" />
      <div className="dev_profile_holder" >
        {batch_2028.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>

      <Underline heading="Senior Mentors" />
      <div className="dev_profile_holder" >
        {guide_team.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>

      <Underline heading="Project Coordinator" />
      <div className="dev_profile_holder" >
        {staff_incharge.map((item) => (
          <Devcard
            key={item.id}
            title={item.name}
            desc={item.batch}
            link={item.linkedin}
            pic={item.pic}
            color={item.color}
          />
        ))}
      </div>
    </div>
  );
};
export default Devpage;